import { RedditShareButton } from 'react-share'

export default function RedditShare({
  url,
  shortDescription,
  children,
}: {
  url: string
  shortDescription: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <RedditShareButton
      className="share-icon"
      url={url}
      title={shortDescription}
      style={{ width: '100%' }}
    >
      {children}
    </RedditShareButton>
  )
}
